import React from "react";
import { Tooltip } from "react-tooltip";

interface RefreshButtonProps {
  onClick: () => void;
  loading?: boolean;
  size?: string;
  color?: string;
  title?: string;
}

const RefreshBtn: React.FC<RefreshButtonProps> = ({
  onClick,
  loading = false,
  size = "18px",
  color = "white",
  title = "Refresh",
}) => {
  return (
    <>
      <button
        id="refresh-btn"
        className="btn btn-dark btn-sm d-flex align-items-center justify-content-center p-1"
        onClick={onClick}
        disabled={loading}
        type="button"
      >
        <box-icon
          name="refresh"
          size={size}
          animation={loading ? "spin" : ""}
          color={color}
        ></box-icon>
      </button>
      {/* Tooltip definition */}
      <Tooltip
        anchorSelect="#refresh-btn"
        place="top"
        content={title}
        style={{
          zIndex: 999999,
          backgroundColor: "#333",
          color: "#fff",
          fontSize: "12px",
          padding: "6px 10px",
          borderRadius: "4px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        }}
      />
    </>
  );
};

export default RefreshBtn;
